import { ChangeDetectionStrategy, Component, EventEmitter, Output, signal } from '@angular/core';

@Component({
  selector: 'wil-admin-tabs',
  standalone: true,
  imports: [],
  templateUrl: './admin-tabs.component.html',
  styleUrl: './admin-tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminTabsComponent {
  @Output() public readonly tabChange = new EventEmitter<AdminTab>();

  // todo create shared const for default tab
  public readonly activeTab = signal<AdminTab>('wheels');

  public readonly tabs = [
    { id: 'wheels' as AdminTab, label: 'My Wheels', icon: 'donut_large' },
    { id: 'clients' as AdminTab, label: 'My Clients', icon: 'people' },
    { id: 'brand' as AdminTab, label: 'My Brand', icon: 'palette' },
  ] as const;

  public onTabClick(tabId: AdminTab): void {
    this.activeTab.set(tabId);
    this.tabChange.emit(tabId); // Emit to parent
  }

  public isTabActive(tabId: AdminTab): boolean {
    return this.activeTab() === tabId;
  }
}
